import { DEFAULT_BREAKPOINT_NAME } from './constants';
import { writeCssRule } from './css/cssRuleWriter';
function findRuleIndex(ruleList, predicate) {
  for (let i = 0; i < ruleList.length; i++) {
    const rule = ruleList.item(i);
    if (predicate(rule)) {
      return i;
    }
  }
  return -1;
}
function isDefaultBreakpoint(mediaQuery) {
  return !mediaQuery || mediaQuery === DEFAULT_BREAKPOINT_NAME;
}
export default class Sheet {
  constructor(sheet) {
    this.defaultRuleIndexCache = {};
    this.mediaRuleIndexCache = {};
    this.sheet = sheet;
  }
  clear() {
    while (this.sheet.cssRules.length) {
      this.sheet.deleteRule(0);
    }
  }
  replaceRuleAtIndex(index, selector, rule, mediaQuery) {
    const ruleAsText = writeCssRule(selector, rule, mediaQuery);
    this.sheet.deleteRule(index);
    const newIndex = this.sheet.insertRule(ruleAsText, index);
    return newIndex;
  }
  compareRules(existingRule, newRule) {
    return existingRule.style.cssText === newRule;
  }
  getCssRulesFromMediaQuery(groupingRule, index) {
    const rules = groupingRule.cssRules;
    return rules.item(index);
  }
  addNonMediaRule(selector, rule) {
    const cacheIndex = findRuleIndex(this.sheet.cssRules, r => r instanceof CSSStyleRule && r.selectorText === selector);
    if (cacheIndex !== -1) {
      this.replaceRuleAtIndex(cacheIndex, selector, rule);
      // this.writeRuleToCache(selector, rule);
      return;
    }
    const ruleAsText = writeCssRule(selector, rule);
    const newIndex = this.sheet.insertRule(ruleAsText, this.sheet.cssRules.length);
    this.defaultRuleIndexCache[selector] = newIndex;
  }
  getOrCreateMediaRuleIndexCache(mediaQuery) {
    if (!this.mediaRuleIndexCache[mediaQuery]) {
      this.mediaRuleIndexCache[mediaQuery] = {};
    }
    return this.mediaRuleIndexCache[mediaQuery];
  }
  addMediaRule(selector, rule, mediaQuery, groupingRule) {
    const indexCache = this.getOrCreateMediaRuleIndexCache(mediaQuery);
    const cacheIndex = indexCache[selector];
    if (cacheIndex !== undefined) {
      const existingRule = this.getCssRulesFromMediaQuery(groupingRule, cacheIndex);
      if (existingRule instanceof CSSStyleRule && this.compareRules(existingRule, rule)) {
        return;
      }
      const ruleAsText = writeCssRule(selector, rule);
      groupingRule.deleteRule(cacheIndex);
      groupingRule.insertRule(ruleAsText, cacheIndex);
      return;
    }
    const ruleAsText = writeCssRule(selector, rule);
    const newIndex = groupingRule.insertRule(ruleAsText,
    // Explicitly set the index to insert the new rule at the end of the media query
    groupingRule.cssRules.length);
    this.mediaRuleIndexCache[mediaQuery][selector] = newIndex;
  }
  addRule(selector, rule, mediaQuery) {
    if (isDefaultBreakpoint(mediaQuery)) {
      this.addNonMediaRule(selector, rule);
      return;
    }

    // @TODO: Test this
    const existingGroupingRuleIndex = findRuleIndex(this.sheet.cssRules, r => r instanceof CSSMediaRule && `@media ${r.media.mediaText}` === mediaQuery);
    let groupingRule;
    if (existingGroupingRuleIndex === -1) {
      const ruleAsText = `${mediaQuery} { }`;
      const newGroupingRuleIndex = this.sheet.insertRule(ruleAsText, this.sheet.cssRules.length);
      this.defaultRuleIndexCache[mediaQuery] = newGroupingRuleIndex;
      groupingRule = this.sheet.cssRules.item(newGroupingRuleIndex);
    } else {
      groupingRule = this.sheet.cssRules.item(existingGroupingRuleIndex);
    }
    this.addMediaRule(selector, rule, mediaQuery, groupingRule);
  }
  deleteNonMediaRule(selector) {
    const cacheIndex = this.defaultRuleIndexCache[selector];
    if (cacheIndex !== undefined) {
      this.sheet.deleteRule(cacheIndex);
      delete this.defaultRuleIndexCache[selector];
    }
  }
  deleteRuleFromMediaList(selector, mediaQuery) {
    const groupingRuleIndex = this.defaultRuleIndexCache[mediaQuery];
    if (groupingRuleIndex === undefined) {
      return;
    }
    const groupingRule = this.sheet.cssRules.item(groupingRuleIndex);
    if (!(groupingRule instanceof CSSGroupingRule)) {
      return;
    }
    const indexCache = this.mediaRuleIndexCache[mediaQuery];
    if (!indexCache) {
      return;
    }
    const ruleIndex = indexCache[selector];
    if (ruleIndex !== undefined) {
      groupingRule.deleteRule(ruleIndex);
      delete indexCache[selector];
    }
  }
  deleteRule(selector, mediaQuery) {
    if (isDefaultBreakpoint(mediaQuery)) {
      this.deleteNonMediaRule(selector);
      return;
    }
    this.deleteRuleFromMediaList(selector, mediaQuery);
  }
}